(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pool-konfigurator-horizon"] && !Shopify.designMode) return;
  try {
    
  function escapePoolConfiguratorHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function poolConfiguratorInit(container) {
    if (!container || container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const form = container.querySelector('.pc-form');
    if (!form) return;

    const storageKey = 'papro:pool-configurator:v5:' + window.location.pathname + ':' + container.id;
    const restartKey = storageKey + ':restart';

    function clearSavedState() {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (error) {
        // Der Konfigurator funktioniert auch, wenn der Browser Storage blockiert.
      }
    }

    const successMessage = container.querySelector('[data-success-message]');
    const restartButton = container.querySelector('[data-restart-configurator]');

    if (successMessage) {
      container.classList.add('is-success');
      clearSavedState();

      if (restartButton) {
        restartButton.addEventListener('click', function() {
          clearSavedState();

          try {
            window.sessionStorage.setItem(restartKey, '1');
          } catch (error) {
            // Der Neustart funktioniert auch, wenn der Browser Storage blockiert.
          }

          const restartUrl = new URL(window.location.href);
          restartUrl.hash = '';
          restartUrl.searchParams.delete('contact_posted');
          window.location.replace(restartUrl.pathname + restartUrl.search);
        });
      }

      window.setTimeout(function() {
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        successMessage.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        if (typeof successMessage.focus === 'function') {
          try {
            successMessage.focus({ preventScroll: true });
          } catch (error) {
            successMessage.focus();
          }
        }
      }, 80);

      return;
    }

    const steps = Array.from(container.querySelectorAll('.pc-step'));
    const nextButton = container.querySelector('[data-next]');
    const prevButton = container.querySelector('[data-prev]');
    const submitButton = container.querySelector('[data-submit]');
    const stepLabel = container.querySelector('.pc-current-step');
    const progressFill = container.querySelector('.pc-progress-fill');
    const review = container.querySelector('[data-review]');
    const summaryField = container.querySelector('[data-summary-field]');
    const volumeField = container.querySelector('[data-volume]');

    let currentStep = 0;

    function saveFormState() {
      const values = {};

      Array.from(form.querySelectorAll('input[name], select[name], textarea[name]')).forEach(function(field) {
        if (!field.name || field.type === 'hidden' || field.hasAttribute('data-summary-field')) return;

        if (field.type === 'radio') {
          if (field.checked) values[field.name] = field.value;
          return;
        }

        if (field.type === 'checkbox') {
          if (!Array.isArray(values[field.name])) values[field.name] = [];
          if (field.checked) values[field.name].push(field.value);
          return;
        }

        values[field.name] = field.value;
      });

      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          currentStep: currentStep,
          savedAt: Date.now(),
          values: values
        }));
      } catch (error) {
        // Der Konfigurator funktioniert auch, wenn der Browser Storage blockiert.
      }
    }

    function restoreFormState() {
      let savedState = null;

      try {
        savedState = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
      } catch (error) {
        savedState = null;
      }

      if (!savedState || !savedState.values) return 0;

      const maxStateAge = 6 * 60 * 60 * 1000;
      if (savedState.savedAt && Date.now() - Number(savedState.savedAt) > maxStateAge) {
        clearSavedState();
        return 0;
      }

      Array.from(form.querySelectorAll('input[name], select[name], textarea[name]')).forEach(function(field) {
        if (!field.name || field.type === 'hidden' || field.hasAttribute('data-summary-field')) return;
        if (!Object.prototype.hasOwnProperty.call(savedState.values, field.name)) return;

        const savedValue = savedState.values[field.name];

        if (field.type === 'radio') {
          field.checked = savedValue === field.value;
          return;
        }

        if (field.type === 'checkbox') {
          field.checked = Array.isArray(savedValue) && savedValue.indexOf(field.value) !== -1;
          return;
        }

        field.value = savedValue;
      });

      const restoredStep = Number(savedState.currentStep);
      return Number.isFinite(restoredStep) ? restoredStep : 0;
    }

    function getRadioValue(name) {
      const field = form.elements[name];
      if (!field) return '';
      if (field instanceof RadioNodeList) {
        const selected = Array.from(field).find(function(item) { return item.checked; });
        return selected ? selected.value : '';
      }
      return field.checked ? field.value : field.value || '';
    }

    function getValue(name) {
      const field = form.elements[name];
      if (!field) return '';
      if (field instanceof RadioNodeList) {
        const collection = Array.from(field);
        if (!collection.length) return '';
        const type = collection[0].type;
        if (type === 'radio') {
          const selected = collection.find(function(item) { return item.checked; });
          return selected ? selected.value : '';
        }
        if (type === 'checkbox') {
          return collection.filter(function(item) { return item.checked; }).map(function(item) { return item.value; }).join(', ');
        }
      }
      if (field.type === 'checkbox') {
        return field.checked ? field.value : '';
      }
      return field.value || '';
    }

    function collectExtras() {
      return Array.from(form.querySelectorAll('[data-extra]:checked')).map(function(input) {
        return input.value;
      });
    }

    function parseDecimal(value) {
      if (!value) return NaN;
      const normalized = String(value).replace(',', '.').trim();
      return Number(normalized);
    }

    function formatDimension(value) {
      if (!value) return '';
      const number = parseDecimal(value);
      if (Number.isNaN(number)) return value;
      return number.toFixed(1).replace('.', ',');
    }

    function calculateVolume() {
      const length = parseDecimal(getValue('contact[laenge]'));
      const width = parseDecimal(getValue('contact[breite]'));
      const depth = parseDecimal(getValue('contact[tiefe]'));
      const shape = getValue('contact[beckenform]');

      if (!length || !width || !depth) return '';

      let volume = length * width * depth;
      if (shape === 'Oval') {
        volume = Math.PI * (length / 2) * (width / 2) * depth;
      }
      if (shape === 'Rund') {
        const diameter = (length + width) / 2;
        volume = Math.PI * Math.pow(diameter / 2, 2) * depth;
      }
      if (shape === 'Nierenförmig') {
        volume = length * width * depth * 0.82;
      }
      if (shape === 'Rechteckig mit Römertreppe') {
        volume = length * width * depth * 0.95;
      }
      if (shape === 'Freiform') {
        volume = length * width * depth * 0.85;
      }
      return volume;
    }

    function buildSummary() {
      const extras = collectExtras();
      const dimensions = [formatDimension(getValue('contact[laenge]')), formatDimension(getValue('contact[breite]')), formatDimension(getValue('contact[tiefe]'))]
        .filter(Boolean)
        .join(' x ');

      const summaryRows = [
        ['Paket', getValue('contact[paket]')],
        ['Pooltyp', getValue('contact[pooltyp]')],
        ['Beckenform', getValue('contact[beckenform]')],
        ['Innenfarbe', getValue('contact[innenfarbe]')],
        ['Maße', dimensions ? dimensions + ' m' : ''],
        ['Technikpaket', getValue('contact[technikpaket]')],
        ['Wasserstand / Skimmerausführung', getValue('contact[skimmer_wasserstand]')],
        ['Extras', extras.join(', ')],
        ['PLZ / Ort', [getValue('contact[plz]'), getValue('contact[ort]')].filter(Boolean).join(' ')],
        ['Zugang', getValue('contact[zugang]')],
        ['Gelände', getValue('contact[gelaende]')],
        ['Grundwasser / Boden', getValue('contact[grundwasser]')],
        ['Technikraum', getValue('contact[technikraum]')],
        ['Montage', getValue('contact[montage]')],
        ['Zeitraum', getValue('contact[wunschzeitraum]')],
        ['Budget', getValue('contact[budget]')],
        ['Notizen', getValue('contact[notizen]')],
        ['Name', getValue('contact[name]')],
        ['E-Mail', getValue('contact[email]')],
        ['Telefon', getValue('contact[telefon]')],
        ['Erreichbarkeit', getValue('contact[erreichbarkeit]')]
      ].filter(function(row) {
        return row[1];
      });

      if (summaryField) {
        summaryField.value = summaryRows.map(function(row) {
          return row[0] + ': ' + row[1];
        }).join('\n');
      }

      if (review) {
        if (!summaryRows.length) {
          review.innerHTML = '<div class="pc-review-item"><span class="pc-review-label">Status</span><div class="pc-review-value">Die Angaben erscheinen hier Schritt für Schritt.</div></div>';
        } else {
          review.innerHTML = summaryRows.map(function(row) {
            return '<div class="pc-review-item"><span class="pc-review-label">' + escapePoolConfiguratorHtml(row[0]) + '</span><div class="pc-review-value">' + escapePoolConfiguratorHtml(row[1]) + '</div></div>';
          }).join('');
        }
      }

      const volume = calculateVolume();
      if (volumeField) {
        volumeField.textContent = volume ? volume.toFixed(1).replace('.', ',') + ' m³' : '-- m³';
      }
    }

    let validationMessageIndex = 0;

    function clearValidationState(scope) {
      const target = scope || container;
      target.querySelectorAll('.pc-field-error').forEach(function(node) {
        node.classList.remove('pc-field-error');
      });
      target.querySelectorAll('[aria-invalid="true"]').forEach(function(node) {
        node.removeAttribute('aria-invalid');
      });
      target.querySelectorAll('[aria-describedby]').forEach(function(node) {
        const describedBy = node.getAttribute('aria-describedby') || '';
        if (describedBy.indexOf(container.id + '-validation-') !== -1) {
          node.removeAttribute('aria-describedby');
        }
      });
      target.querySelectorAll('.pc-validation-message').forEach(function(node) {
        node.remove();
      });
    }

    function addValidationMessage(messageContainer, message, fields) {
      if (!messageContainer) return;

      validationMessageIndex += 1;
      const messageNode = document.createElement('p');
      messageNode.className = 'pc-validation-message';
      messageNode.id = container.id + '-validation-' + validationMessageIndex;
      messageNode.setAttribute('role', 'alert');
      messageNode.textContent = message;
      messageContainer.appendChild(messageNode);

      (fields || []).forEach(function(field) {
        if (field) field.setAttribute('aria-describedby', messageNode.id);
      });
    }

    function getValidationMessage(field) {
      if (!field) return 'Bitte prüfe diese Angabe.';

      const value = typeof field.value === 'string' ? field.value.trim() : field.value;
      if (field.required && !value) return 'Bitte fülle dieses Pflichtfeld aus.';

      if (field.type === 'email' && (field.validity.typeMismatch || field.validity.patternMismatch)) {
        return 'Bitte gib eine gültige E-Mail-Adresse ein, zum Beispiel name@beispiel.de.';
      }

      if (field.validity.rangeUnderflow && field.min) {
        return 'Bitte gib einen Wert von mindestens ' + String(field.min).replace('.', ',') + ' ein.';
      }

      if (field.validity.rangeOverflow && field.max) {
        return 'Bitte gib einen Wert von höchstens ' + String(field.max).replace('.', ',') + ' ein.';
      }

      if (field.validity.badInput || field.validity.stepMismatch) {
        return 'Bitte gib einen gültigen Zahlenwert ein.';
      }

      return 'Bitte prüfe diese Angabe.';
    }

    function markChoiceGroupInvalid(items, messageContainer) {
      items.forEach(function(item) {
        if (!item) return;
        item.setAttribute('aria-invalid', 'true');
        const option = item.closest ? item.closest('.pc-option') : null;
        const card = option ? option.querySelector('.pc-option-card') : null;
        if (card) card.classList.add('pc-field-error');
      });
      addValidationMessage(messageContainer, 'Bitte triff eine Auswahl.', items.filter(Boolean));
    }

    function markFieldInvalid(field, messageContainer) {
      if (!field) return;
      field.setAttribute('aria-invalid', 'true');
      field.classList.add('pc-field-error');
      addValidationMessage(messageContainer, getValidationMessage(field), [field]);
    }

    function validateStep() {
      const activeStep = steps[currentStep];
      if (!activeStep) return { valid: true };

      clearValidationState(activeStep);

      const requiredFields = Array.from(activeStep.querySelectorAll('[required]'));
      const visitedNames = new Set();

      for (let index = 0; index < requiredFields.length; index += 1) {
        const field = requiredFields[index];
        const isChoice = field.type === 'radio' || field.type === 'checkbox';

        if (isChoice && field.name) {
          if (visitedNames.has(field.name)) continue;
          visitedNames.add(field.name);

          const choiceGroup = form.elements[field.name];
          const items = choiceGroup instanceof RadioNodeList ? Array.from(choiceGroup) : [choiceGroup];
          const hasValue = items.some(function(item) { return item && item.checked; });

          if (!hasValue) {
            const messageContainer = (items[0] && (items[0].closest('fieldset') || items[0].closest('.pc-field') || items[0].closest('.pc-option'))) || activeStep;
            markChoiceGroupInvalid(items, messageContainer);
            return {
              valid: false,
              field: items[0] || null,
              target: (items[0] && (items[0].closest('fieldset') || items[0].closest('.pc-field') || items[0].closest('.pc-option'))) || activeStep
            };
          }
        } else {
          const trimmedValue = typeof field.value === 'string' ? field.value.trim() : field.value;
          const isBlankRequiredField = field.required && !trimmedValue;

          if (!isBlankRequiredField && field.checkValidity()) continue;

          const messageContainer = field.closest('.pc-field') || field.closest('fieldset') || field.parentElement || activeStep;
          markFieldInvalid(field, messageContainer);
          return {
            valid: false,
            field: field,
            target: field.closest('.pc-field') || field.closest('fieldset') || field
          };
        }
      }

      return { valid: true };
    }

    function handleInvalidValidation(validation) {
      const invalidTarget = validation.target || steps[currentStep] || container;
      window.requestAnimationFrame(function() {
        scrollToTarget(invalidTarget, 12);
        window.setTimeout(function() {
          scrollToTarget(invalidTarget, 12);
          if (validation.field && typeof validation.field.focus === 'function') {
            try {
              validation.field.focus({ preventScroll: true });
            } catch (error) {
              validation.field.focus();
            }
          }
          // Die sichtbare, einheitliche Fehlermeldung steht direkt am betroffenen Feld.
        }, 140);
      });
    }

    function getStickyOffset() {
      const candidates = Array.from(document.querySelectorAll('header, .shopify-section-header, .header-wrapper, .header, sticky-header, [data-header]'));
      let offset = 24;

      candidates.forEach(function(node) {
        if (!node || !node.getBoundingClientRect) return;
        const style = window.getComputedStyle(node);
        const isSticky = style.position === 'sticky' || style.position === 'fixed';
        const height = node.getBoundingClientRect().height || 0;
        if (isSticky && height > 0 && height < 240) {
          offset = Math.max(offset, Math.ceil(height) + 16);
        }
      });

      return offset;
    }

    function getScrollableAncestor(node) {
      let current = node ? node.parentElement : null;
      while (current && current !== document.body) {
        const style = window.getComputedStyle(current);
        const canScroll = /(auto|scroll|overlay)/.test(style.overflowY || '');
        if (canScroll && current.scrollHeight > current.clientHeight + 4) {
          return current;
        }
        current = current.parentElement;
      }
      return null;
    }

    function scrollToTarget(target, extraOffset) {
      const destination = target || container;
      if (!destination) return;

      const stickyOffset = getStickyOffset() + (extraOffset || 0);
      const scrollParent = getScrollableAncestor(destination);

      if (scrollParent) {
        const parentBox = scrollParent.getBoundingClientRect();
        const targetBox = destination.getBoundingClientRect();
        const nextTop = scrollParent.scrollTop + (targetBox.top - parentBox.top) - 24;
        scrollParent.scrollTo({
          top: Math.max(0, nextTop),
          behavior: (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth'
        });
      }

      const pageTop = destination.getBoundingClientRect().top + window.pageYOffset - stickyOffset;

      window.scrollTo({
        top: Math.max(0, pageTop),
        behavior: (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth'
      });
    }

    function scrollToStepTop() {
      const target = container.querySelector('.pc-progress-wrap') || container.querySelector('.pc-head') || container;
      scrollToTarget(target, 12);
    }

    function showStep(index, options) {
      const settings = options || {};
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach(function(step, stepIndex) {
        step.classList.toggle('is-active', stepIndex === currentStep);
      });

      if (stepLabel) stepLabel.textContent = String(currentStep + 1);
      if (progressFill) progressFill.style.width = (((currentStep + 1) / steps.length) * 100).toFixed(2) + '%';

      if (prevButton) prevButton.hidden = currentStep === 0;
      if (nextButton) nextButton.hidden = currentStep === steps.length - 1;
      if (submitButton) submitButton.hidden = currentStep !== steps.length - 1;

      clearValidationState(steps[currentStep]);
      buildSummary();
      saveFormState();

      if (settings.scrollToTop) {
        window.requestAnimationFrame(function() {
          scrollToStepTop();
          window.setTimeout(function() {
            scrollToStepTop();
            const stepTitle = steps[currentStep] ? steps[currentStep].querySelector('.pc-step-title') : null;
            if (stepTitle && typeof stepTitle.focus === 'function') {
              stepTitle.focus({ preventScroll: true });
            }
          }, 140);
        });
      }
    }

    form.addEventListener('input', function() {
      clearValidationState(steps[currentStep]);
      buildSummary();
      saveFormState();
    });

    form.addEventListener('change', function() {
      clearValidationState(steps[currentStep]);
      buildSummary();
      saveFormState();
    });

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        const validation = validateStep();

        if (!validation.valid) {
          handleInvalidValidation(validation);
          return;
        }

        showStep(currentStep + 1, { scrollToTop: true });
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        showStep(currentStep - 1, { scrollToTop: true });
      });
    }

    form.addEventListener('submit', function(event) {
      if (currentStep !== steps.length - 1) {
        event.preventDefault();
        const validation = validateStep();
        if (!validation.valid) {
          handleInvalidValidation(validation);
          return;
        }
        showStep(currentStep + 1, { scrollToTop: true });
        return;
      }

      const validation = validateStep();
      if (!validation.valid) {
        event.preventDefault();
        handleInvalidValidation(validation);
        return;
      }

      buildSummary();
      saveFormState();

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.textContent = 'Wird gesendet …';
      }
      form.setAttribute('aria-busy', 'true');
    });

    let shouldScrollToConfigurator = false;
    try {
      shouldScrollToConfigurator = window.sessionStorage.getItem(restartKey) === '1';
      window.sessionStorage.removeItem(restartKey);
    } catch (error) {
      // Der Konfigurator funktioniert auch, wenn der Browser Storage blockiert.
    }

    const hasServerErrors = Boolean(container.querySelector('.pc-errors'));
    const restoredStep = restoreFormState();
    showStep(hasServerErrors ? steps.length - 1 : restoredStep);

    if (shouldScrollToConfigurator && !hasServerErrors) {
      window.setTimeout(function() {
        scrollToStepTop();
      }, 120);
    }

    if (hasServerErrors) {
      window.setTimeout(function() {
        const errorMessage = container.querySelector('.pc-errors');
        if (!errorMessage) return;
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        errorMessage.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        if (typeof errorMessage.focus === 'function') {
          errorMessage.setAttribute('tabindex', '-1');
          try {
            errorMessage.focus({ preventScroll: true });
          } catch (error) {
            errorMessage.focus();
          }
        }
      }, 120);
    }
  }

  function initAllPoolConfigurators(context) {
    const scope = context || document;
    scope.querySelectorAll('[data-pool-configurator]').forEach(function(element) {
      poolConfiguratorInit(element);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllPoolConfigurators(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAllPoolConfigurators(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
